import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { type AppState } from '../app.store';

const spreadsheetCellDataSelector = (state: AppState) => state.spreadsheetCellData;
export const useSpreadsheetCellDataSelector = () => useSelector(spreadsheetCellDataSelector);
